import { HackerNewsHttpService } from "./HackerNewsHttpService";
export class StoryService {
    static async getLatestStories(limit = 10, offset = 0) {
        let storyIdsHttpResponse = await StoryService._getTopStories();
        const storyPromises = [];
        let index = 0;
        storyIdsHttpResponse = storyIdsHttpResponse.slice(offset, storyIdsHttpResponse.length);
        for (const storyId of storyIdsHttpResponse) {
            // store the promise
            storyPromises.push(HackerNewsHttpService.get(`item/${storyId}.json`));
            if (index === limit - 1 && limit !== -1) {
                break;
            }
            index++;
        }
        // To fetch the stories in parallel and not in synchronous mode
        return await Promise.all(storyPromises);
    }
    static async _getTopStories() {
        if (StoryService._ALL_STORY_IDS.length === 0) {
            StoryService._ALL_STORY_IDS = await HackerNewsHttpService.get('topstories.json');
        }
        return this._ALL_STORY_IDS;
    }
}
StoryService._ALL_STORY_IDS = [];
